export default "__VITE_ASSET__C9Ncvjt$__"